export default __webpack_public_path__ + "./images/pg.09911227.png";